export const memoryHowItWorks = (
  <>
    <p>
      O Memory Lab funciona através de desafios interativos que treinam diferentes áreas da memória humana. 
      Cada jogo foca em uma habilidade específica e evolui conforme você avança.
    </p>

    <div>
      <strong>🔢 Memória Sequencial</strong>
      <p>
        Você observa uma sequência de números e precisa reproduzi-la corretamente. 
        Esse desafio trabalha foco, lógica e memória de curto prazo.
      </p>
    </div>

    <div>
      <strong>👁️ Memória Visual</strong>
      <p>
        Aqui o objetivo é identificar e lembrar padrões dentro de uma grade. 
        Esse treino estimula percepção, atenção e reconhecimento visual.
      </p>
    </div>

    <div>
      <strong>⏱️ Memória de Retenção</strong>
      <p>
        Você precisa guardar uma informação e recuperá-la após uma distração, 
        simulando situações reais do dia a dia.
      </p>
    </div>

    <p>
      Conforme você avança, os desafios ficam mais difíceis, exigindo mais concentração. 
      O sistema também registra seu desempenho para mostrar qual tipo de memória é mais forte em você.
    </p>
  </>
);